import React from 'react';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import Divider from '../../Shared/UI/Divider/components/Divider';
import Button from '../../Shared/UI/Button/components/Button';
import EditPencilIcon from '../../Shared/UI/EditPencilIcon/components/EditPencilIcon';
import UserBiographyUpdateForm from './UserBiographyUpdateForm';

import { useProfileState, useProfileActions } from './ProfileContext';

import styles from './ProfileUserBiography.module.scss';

const ProfileUserBiography = () => {
  const state = useProfileState();
  const { openUserBiographyUpdateModal, closeUserBiographyUpdateModal } = useProfileActions();

  const openUserBiographyUpdateModalIfPermitted = () => {
    if (state.user?.isAuthenticatedUser) {
      openUserBiographyUpdateModal();
    }
  };

  const closeUserBiographyUpdateModalIfPermitted = () => {
    if (state.user?.isAuthenticatedUser) {
      closeUserBiographyUpdateModal();
    }
  };

  const biographyStyling =
    !state.user?.biography ?
    styles.visibleOnlyToYou :
    styles.bio;
  const noBiographyMessage = 'This section is currently only visible to you since you do not currently have a bio to display.';
  const biographyContent = state.user?.biography || noBiographyMessage;

  if (state.loading) {
    return (
      <section id={styles.userBiographySection}>
        <Divider />
        <div id={styles.userBiographyLoading} />
      </section>
    );
  }

  return (
    <>
      {(state.user?.biography || state.user?.isAuthenticatedUser) && (
        <section id={styles.userBiographySection}>
          <Divider />
          <div id={styles.userBiographySectionHeader}>
            <h2 className={biographyStyling}>
              Bio
            </h2>
            {state.user?.isAuthenticatedUser && (
              <Button
                variant="ghost"
                icon={<EditPencilIcon />}
                iconOnly
                aria-label="Edit Bio"
                onClick={openUserBiographyUpdateModalIfPermitted}
              />
            )}
          </div>
          <p className={biographyStyling}>
            {biographyContent}
          </p>
        </section>
      )}
      <StandardModal
        isOpen={state.userBiographyUpdateModalIsOpen}
        contentLabel={'Update Biography'}
        onRequestClose={closeUserBiographyUpdateModalIfPermitted}
      >
        <UserBiographyUpdateForm />
      </StandardModal>
    </>
  );
};

export default ProfileUserBiography;
